import _extends from "@babel/runtime/helpers/extends";
import _createClass from "@babel/runtime/helpers/createClass";
import { HelpTip, Tip as InnerTip, Title as InnerTitle } from '@alilc/lowcode-editor-core';
import { Balloon, Breadcrumb, Button, Card, Checkbox, DatePicker, Dialog, Dropdown, Form, Icon, Input, Loading, Message, Overlay, Pagination, Radio, Search, Select, SplitButton, Step, Switch, Tab, Table, Tree, TreeSelect, Upload, Divider } from '@alifd/next';
import { ContextMenu } from '../components/context-menu';
import { editorSymbol } from '../symbols';
export var CommonUI = /*#__PURE__*/function () {
  function CommonUI(editor) {
    this[editorSymbol] = void 0;
    this.Balloon = Balloon;
    this.Breadcrumb = Breadcrumb;
    this.Button = Button;
    this.Card = Card;
    this.Checkbox = Checkbox;
    this.DatePicker = DatePicker;
    this.Dialog = Dialog;
    this.Dropdown = Dropdown;
    this.Form = Form;
    this.Icon = Icon;
    this.Input = Input;
    this.Loading = Loading;
    this.Message = Message;
    this.Overlay = Overlay;
    this.Pagination = Pagination;
    this.Radio = Radio;
    this.Search = Search;
    this.Select = Select;
    this.SplitButton = SplitButton;
    this.Step = Step;
    this.Switch = Switch;
    this.Tab = Tab;
    this.Table = Table;
    this.Tree = Tree;
    this.TreeSelect = TreeSelect;
    this.Upload = Upload;
    this.Divider = Divider;
    this.ContextMenu = void 0;
    this[editorSymbol] = editor;
    var innerContextMenu = function innerContextMenu(props) {
      var pluginContext = editor.get('pluginContext');
      return /*#__PURE__*/React.createElement(ContextMenu, _extends({}, props, {
        pluginContext: pluginContext
      }));
    };
    innerContextMenu.create = function (menus, event) {
      var pluginContext = editor.get('pluginContext');
      return ContextMenu.create(pluginContext, menus, event);
    };
    this.ContextMenu = innerContextMenu;
  }
  _createClass(CommonUI, [{
    key: "Tip",
    get: function get() {
      return InnerTip;
    }
  }, {
    key: "HelpTip",
    get: function get() {
      return HelpTip;
    }
  }, {
    key: "Title",
    get: function get() {
      return InnerTitle;
    }
  }]);
  return CommonUI;
}();